var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("skoly-menu", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c("main", { staticClass: "profileDashboard" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("h2", [_vm._v("Zoznam z logov")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "bg-white pl-30 pt-30 pr-30 pb-30 mb-30 rounded-10"
                },
                [
                  _c(
                    "table",
                    { staticClass: "mb-0 log-list" },
                    _vm._l(_vm.logyBodov, function(log, index) {
                      return _c(
                        "tr",
                        {
                          key: index,
                          staticClass: "log d-flex align-items-center"
                        },
                        [
                          _c("td", { attrs: { width: "150" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(log.created_at, "D.M.YYYY")
                              ) +
                                " " +
                                _vm._s(
                                  _vm._f("moment")(log.created_at, "HH:mm")
                                )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { attrs: { width: "40", align: "left" } }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "8",
                                  height: "50",
                                  viewBox: "0 0 8 50"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      id: "Group_9",
                                      "data-name": "Group 9",
                                      transform: "translate(-21)"
                                    }
                                  },
                                  [
                                    _c("line", {
                                      attrs: {
                                        id: "Line_1",
                                        "data-name": "Line 1",
                                        y2: "50",
                                        transform: "translate(25)",
                                        fill: "none",
                                        stroke: "rgba(0,0,0,0.1)",
                                        "stroke-width": "1"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "Ellipse_1",
                                          "data-name": "Ellipse 1",
                                          transform: "translate(21 21)",
                                          fill: "#e5e5e5",
                                          stroke: "#e5e5e5",
                                          "stroke-width": "1"
                                        }
                                      },
                                      [
                                        _c("circle", {
                                          attrs: {
                                            cx: "4",
                                            cy: "4",
                                            r: "4",
                                            stroke: "none"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("circle", {
                                          attrs: {
                                            cx: "4",
                                            cy: "4",
                                            r: "3.5",
                                            fill: "none"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "mb-0" },
                            [
                              _vm._v(
                                "Aktivita:\n                                    "
                              ),
                              log.cinnost === "stastie-kravicky"
                                ? [
                                    _c("b", { staticClass: "text-dark" }, [
                                      _vm._v("Šťastie kravičky")
                                    ])
                                  ]
                                : log.cinnost === "kvizova-uloha"
                                ? [
                                    _c("b", { staticClass: "text-dark" }, [
                                      _vm._v("Kvízová úloha")
                                    ])
                                  ]
                                : [
                                    _c("b", { staticClass: "text-dark" }, [
                                      _vm._v(_vm._s(log.cinnost))
                                    ])
                                  ],
                              _vm._v("; získaný počet bodov "),
                              _c("b", { staticClass: "text-success" }, [
                                _vm._v("+" + _vm._s(log.skolske_body_zmena))
                              ]),
                              _vm._v("; nový bodový stav = "),
                              _c("b", { staticClass: "text-primary" }, [
                                _vm._v(_vm._s(log.skolske_body_po))
                              ])
                            ],
                            2
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _vm.paginateCursor
                ? _c(
                    "a",
                    {
                      staticClass: "btn --primary",
                      attrs: { href: "#" },
                      on: { click: _vm.loadLogData }
                    },
                    [_vm._v("Zobraziť viac")]
                  )
                : _vm._e()
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }